// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Label,
  Button,
  Spinner,
  CardBody,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  FloatButton,
  BillsToPayCards,
  DropdownDatatable,
  BillsToPayFilters,
} from '../../containers/componentsInjection';

export const BillsToPayListPage = ({
  bills,
  toggle,
  filter,
  loading,
  summary,
  columns,
  setFilter,
  validation,
  handleEdit,
  handleDelete,
  setBillsByHash,
  setSelectedFile,
  setIsConfirmAction,
}) => {
  return (
    <PageWrapper title={'Contas a Pagar'}>
      <Card>
        <CardBody>
          <BillsToPayCards data={summary ? summary : {}} />

          <Form
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row md={12} className="mb-4 d-flex align-items-center">
              <Col md={5}>
                <Label className="form-label">Período</Label>
                <div className="d-flex justify-content-center align-items-center">
                  <Input
                    type="date"
                    id="starts"
                    value={validation.values.starts}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                  />

                  <span className="m-2">a</span>

                  <Input
                    type="date"
                    id="ends"
                    value={validation.values.ends}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                  />

                  <Button
                    type="submit"
                    color="primary"
                    className="d-block border-0 ms-3"
                  >
                    Filtrar
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>

          <BillsToPayFilters filter={filter} setFilter={setFilter} />

          <DropdownDatatable
            isBills
            loading={loading}
            progressPending={loading}
            progressComponent={
              <Spinner
                type="grow"
                color="primary"
                style={{
                  margin: 25,
                }}
              />
            }
            columns={columns}
            data={bills || []}
            pagination
            persistTableHead
            actions={[
              {
                id: 1,
                name: 'confirm',
                label: 'Confirmar',
                onPress: (cellProps) => handleEdit(cellProps, true),
                icon: 'la-check',
                classNameColorIcon: 'primary',
              },
              {
                id: 2,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => handleEdit(cellProps, false),
                icon: 'la-pen',
                classNameColorIcon: 'primary',
              },
              // {
              //   id: 3,
              //   name: 'duplicate',
              //   label: 'Duplicar',
              //   // onPress: (cellProps) => handleEdit(cellProps),
              //   icon: 'la-copy',
              //   classNameColorIcon: 'primary',
              // },
            ]}
            noDataComponent="Nenhum registro encontrado!"
            handleDelete={(cellProps) => handleDelete(cellProps)}
            keysSearch={['description']}
          />
        </CardBody>
      </Card>

      <FloatButton
        type="button"
        handleButton={() => {
          setSelectedFile([]);
          setBillsByHash(null);
          setIsConfirmAction(false);
          toggle();
        }}
      />
    </PageWrapper>
  );
};
